import {
  ProFormCheckbox,
  ProFormInstance,
  ProFormRadio,
  ProFormRate,
  ProFormText,
  ProFormTextArea,
  StepsForm,
} from '@ant-design/pro-components';
import { Card, Image } from 'antd';
import { QuestionType, Session, SessionMetadata } from 'pages/khaosat/models';
import React, { useEffect, useRef, useState } from 'react';
import './stylePreivew.css';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import CustomButton from 'base/ui/components/Button';
import { cloneDeep } from 'lodash';
import usePartialState from 'hooks/usePartialState';

type Props = {
  dataPreview:
  | {
    metaData: SessionMetadata;
    questions: Session[];
  }
  | undefined;
  image: string | undefined;
};

type FormValue = {
  jobInfo: {
    name: string;
    type: number;
  };
  syncTableInfo: {
    title: string;
  };
};

const formValue: FormValue = {
  jobInfo: {
    name: 'normal job',
    type: 1,
  },
  syncTableInfo: {
    title: 'example table title',
  },
};

const desc = ['Rất kém', 'Kém', 'Bình thường', 'Hài lòng', 'Rất hài lòng']



const waitTime = (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(formValue);
    }, time);
  });
};

const PreviewModal = ({ dataPreview, image }: Props) => {
  const [current, setCurrent] = useState(0);

  const [nextSession, setNextSession] = useState({
    isSwitch: false,
    next: undefined as number | undefined,
    prev: undefined as number | undefined,
  });

  // const [valueRate, setValueRate] = useState<{
  //   idPhan: string,
  //   idCauHoi: string,
  //   valueRate: number,
  // }[]>([])

  // hoàn thành đánh giá
  const [isComplete, setIsComplete] = useState(false);

  const formMapRef = useRef<React.MutableRefObject<ProFormInstance<any> | undefined>[]>([]);

  useEffect(() => {
    waitTime(1000).then(() => {
      formMapRef?.current?.forEach((formInstanceRef) => {
        formInstanceRef?.current?.setFieldsValue(formValue);
      });
    });
  }, []);



  // useEffect(() => {
  //   console.log('dataPreview', dataPreview);
  // }, [])

  // Lưu tạm idpart khi chọn loại câu hỏi là Rate để làm nút chuyển phần
  const [currentPartIdRate, setCurrentPartIdRate] = usePartialState({
    idPart: '',
    nameQues: ''
  })

  // console.log(dataPreview);


  return (
    <div className={`w-full md:py-3 md:px-5`}>
      <div className="max-w-[700px] mx-auto">
        {/* header */}
        <div className="flex flex-col items-center justify-center bg-white pb-3 mb-8 rounded-sm shadow-box">
          <div className="w-full h-3 bg-primary rounded-t-sm"></div>
          <div className="my-2">
            <Image preview={false} className="rounded-[10px] w-[350px] md:!max-w-[600px]" src={image} />
          </div>
          <h1 className="uppercase whitespace-normal text-xl px-2 font-bold mt-4 text">
            {dataPreview?.metaData.title}
          </h1>
          <div className="max-w-[600px] px-1 py-2">
            <p className="whitespace-normal text-center text-base">{dataPreview?.metaData.description}</p>
          </div>
        </div>
        {/* TEST FORM */}
        <div className={`mt-4 [&_.ant-pro-steps-form-step-active]:!mt-0`}>
          {/* Nếu hoàn thành đánh giá thì ẩn form */}
          {!isComplete && (
            <StepsForm
              stepsRender={(steps, dom) => {
                if (dataPreview?.questions.length! < 2) {
                  return <></>
                } else {
                  return dom
                }
              }}
              current={current}
              onCurrentChange={(curr) => {
                if (nextSession.isSwitch) {
                  if (curr > current) setCurrent(nextSession.next || 0);
                  else setCurrent(nextSession.prev || 0);
                  // setNextSession({
                  //   isSwitch: false,
                  //   next: undefined,
                  //   prev: undefined,
                  // });
                } else {
                  setCurrent(curr);
                }
              }}
              onFormChange={(name, info) => {
                const value = info.changedFields.length ? info.changedFields[0].value + '' : undefined;

                if (value && value.includes('_')) {
                  const partId = value.split('_')[0];
                  const partIndex = dataPreview?.questions.findIndex((q) => q.id === partId);
                  // setCurrent(partIndex as number);
                  setNextSession({
                    isSwitch: true,
                    next: partIndex,
                    prev: current,
                  });
                } else {
                  if (currentPartIdRate.idPart && (currentPartIdRate.nameQues === 'RATE')) {
                    const partIndex = dataPreview?.questions.findIndex((q) => q.id === currentPartIdRate.idPart);
                    setNextSession({
                      isSwitch: true,
                      next: partIndex,
                      prev: current,
                    });
                  } else {
                    setCurrentPartIdRate({ idPart: '', nameQues: '' })
                    setNextSession({
                      isSwitch: false,
                      next: undefined,
                      prev: undefined,
                    });
                  }
                }



              }}
              containerStyle={{
                background: 'white',
                padding: '10px',
                borderRadius: '3px',
                marginTop: '15px',
                width: '100%',
                minWidth: 'auto',
              }}
              formMapRef={formMapRef}
              onFinish={(values) => {
                setIsComplete(true);

                return Promise.resolve(true);
              }}
            >
              {dataPreview?.questions.map((item, index) => {
                return (
                  <StepsForm.StepForm className={`!mt-0 `} key={index} name={`step${index}`} title={`Phần ${index + 1}`}>
                    <div className="bg-primary rounded-[2px] mb-2 text-white py-2">
                      <h5 className={`font-semibold whitespace-normal text-center text-base ${!item.title ? 'hidden' : ''}`}>{item.title}</h5>
                      <h6 className={`font-semibold whitespace-normal text-center ${!item.title ? 'hidden' : ''}`}>{item.description}</h6>
                    </div>

                    {item.questions?.map((ques, idx) => {
                      return (
                        <div key={idx}>
                          <Card className="[&_.ant-card-body]:!py-0 !border-none">
                            <p className="font-semibold mb-2">
                              {ques.title} {ques.required ? <span className="font-normal text-red-500"> *</span> : null}
                            </p>

                            {/* câu hỏi nhiều lựa chọn */}
                            {ques.type === QuestionType.MULTI_CHOICE ? (
                              <ProFormCheckbox.Group
                                layout="vertical"
                                name={[`phan${index + 1}`, `${ques.id}`, 'multiChoice']}
                                rules={[
                                  {
                                    required: ques.required,
                                    message: (
                                      <div className="flex items-center gap-x-1 leading-none">
                                        <AiOutlineInfoCircle className="text-base" />
                                        <span>Đây là một câu hỏi bắt buộc</span>
                                      </div>
                                    ),
                                  },
                                ]}
                                options={ques.answers?.map((item) => {
                                  const valueEn = encodeURIComponent(item.title);
                                  return {
                                    label: item.title,
                                    value: `${valueEn}${item.score ? '*sc' + item.score : ''}`,
                                  };
                                })}
                              />
                            ) : null}
                            {/* câu hỏi trắc nghiệm */}
                            {ques.type === QuestionType.QUIZ ? (
                              <ProFormRadio.Group
                                layout="vertical"
                                rules={[
                                  {
                                    required: ques.required,
                                    message: (
                                      <div className="flex items-center gap-x-1 leading-none">
                                        <AiOutlineInfoCircle className="text-base" />
                                        <span>Đây là một câu hỏi bắt buộc</span>
                                      </div>
                                    ),
                                  },
                                ]}
                                // getValueFromEvent={(e) => {
                                //   // setIdNextSession(e.target.value);
                                //   // setId(e.target.value);
                                // }}
                                name={[`phan${index + 1}`, `${ques.id}`, 'quiz']}
                                options={ques.answers?.map((item, indexQues) => {
                                  const valueEn = encodeURIComponent(item.title);
                                  return {
                                    value: `${item.part ? item.part + '_' : ''}${valueEn}${item.score ? '*sc' + item.score : ''
                                      }`,
                                    label: item.title,
                                  };
                                })}
                              />
                            ) : null}
                            {/* câu hỏi trả lời ngắn */}
                            {ques.type === QuestionType.SHORT_ANSWER ? (
                              <ProFormText
                                rules={[
                                  {
                                    required: ques.required,
                                    message: (
                                      <div className="flex items-center gap-x-1 leading-none">
                                        <AiOutlineInfoCircle className="text-base" />
                                        <span>Đây là một câu hỏi bắt buộc</span>
                                      </div>
                                    ),
                                  },
                                ]}
                                name={[`phan${index + 1}`, `${ques.id}`, 'shortText']}
                              />
                            ) : null}
                            {/* câu hỏi trả lời đoạn */}
                            {ques.type === QuestionType.LONG_ANSWER ? (
                              <ProFormTextArea
                                name={[`phan${index + 1}`, `${ques.id}`, 'largeText']}
                                placeholder="Vui lòng nhập câu trả lời"
                                rules={[
                                  {
                                    required: ques.required,
                                    message: (
                                      <div className="flex items-center gap-x-1 leading-none">
                                        <AiOutlineInfoCircle className="text-base" />
                                        <span>Đây là một câu hỏi bắt buộc</span>
                                      </div>
                                    ),
                                  },
                                ]}
                              />
                            ) : null}
                            {/* câu hỏi khảo sát đánh giá sao */}
                            {ques.type === QuestionType.RATE ? (
                              <div className='flex justify-center items-center flex-col'>
                                <ProFormRate
                                  fieldProps={{
                                    allowHalf: false,
                                    style: {
                                      fontSize: '35px',
                                    },
                                    tooltips: desc,
                                    onChange(value) {
                                      setCurrentPartIdRate({ idPart: ques.answers && ques.answers[value - 1]?.part, nameQues: 'RATE' })
                                    },
                                  }}
                                  rules={[
                                    {
                                      required: ques.required,
                                      message: (
                                        <div className="flex items-center gap-x-1 leading-none">
                                          <AiOutlineInfoCircle className="text-base" />
                                          <span>Đây là một câu hỏi bắt buộc</span>
                                        </div>
                                      ),
                                    },
                                  ]}

                                  name={[`phan${index + 1}`, `${ques.id}`, 'rate']}
                                />
                                {/* Text hiển thị khi onchange Rate */}
                                <div className='-mt-5'>
                                  {desc[formMapRef.current[index]?.current?.getFieldValue([`phan${index + 1}`, `${ques.id}`, 'rate']) - 1]}
                                </div>
                              </div>

                            ) : null}
                          </Card>
                        </div>
                      );
                    })}
                  </StepsForm.StepForm>
                );
              })}
              {/* <StepsForm.StepForm
              className="h-[100px]"
              name={`step${dataPreview?.questions.length || 1}`}
              title={'Xác nhận'}
            ></StepsForm.StepForm> */}
            </StepsForm>
          )}
          {isComplete && (
            <div className="bg-white py-8 px-3 pb-3 rounded-sm shadow-box">
              <p className="text-center whitespace-pre-line text-base font-semibold">
                {dataPreview?.metaData.descriptionLast}
              </p>
              <CustomButton
                className={'mx-auto mt-3'}
                onClick={() => {
                  setIsComplete(false);
                  setCurrent(0);
                }}
                type="primary"
              >
                Khảo sát lại
              </CustomButton>
            </div>
          )}






        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
